export const PEOPLE = [
  { id: 'ss', photo: 'Simon.webp', name: 'Simon Schulz' },
  { id: 'kg', photo: 'Kosta.webp', name: 'Kostiantyn Garbar' },
  { id: 'jw', photo: 'Jan.webp', name: 'Jan Wagebach' },
] as const
